import { useState, useEffect } from "react";
import { useSearchParams, useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store/combineReducer";
import DataCompany from "./DataCompany";
import DataParticularPatient from "./DataParticularPatient";
import Contactos from "./Contactos";
import Sucursales from "./Sucursales";
import EditCompanyModal from "../others/editCompany";
import EditParticularPatientModal from "../others/editParticularPatient";
import DatosSucursal from "./DataBranchOffice";
import {
  getDisplayClientCode,
  isFranchiseTenant,
} from "../../utils/franchise/franchiseAbsenteeismMenu";

const dataProfiles: any = {
  "Sucursal": <DatosSucursal />,
  "Casa Matriz": <DataCompany />
}

const PROFILE = () => {
  const reduxStore = useSelector((state: RootState) => state.user);
  const chosenRole: string = reduxStore?.currentRole;

  const CUENTA: any = {
    COMPANY_ADMIN: <COMPANYPROFILE />,
    PARTICULAR_CLIENT: <PARTICULAR_PATIENT_PROFILE />,
  };
  return CUENTA[chosenRole] ? CUENTA[chosenRole] : <></>;
};

const COMPANYPROFILE = () => {
  const chosenCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]);
  const franchiseState = useSelector((state: RootState) => state.franchise);
  const isFranchise = isFranchiseTenant(franchiseState);
  const location = useLocation();
  const [searchParams] = useSearchParams("");

  // Helper Functions
  const getCurrentTab = () => {
    const pathname = window.location.pathname;
    if (pathname.includes("Datos-Empresa")) return "datos";
    if (pathname.includes("Contactos")) return "contactos";
    if (pathname.includes("Sucursales")) return "sucursales";
    return "datos"; // Default to "datos" instead of empty string
  };

  // States
  const [currentTab, setCurrentTab] = useState<string>(() => getCurrentTab());
  const [toggleEditarEmpresa, settoggleEditarEmpresa] = useState(
    searchParams.get("modalEditarEmpresa") === "active"
  );

  // Effects
  useEffect(() => {
    setCurrentTab(getCurrentTab());
  }, [location]);

  useEffect(() => {
    const modalEditarEmpresa = searchParams.get("modalEditarEmpresa");
    if (modalEditarEmpresa === "active") {
      settoggleEditarEmpresa(true);
    }
  }, [searchParams]);

  const tabs = [
    { id: "datos", label: "Datos de la empresa", path: "/Cuenta/Datos-Empresa" },
    { id: "contactos", label: "Personas de contacto", path: "/Cuenta/Contactos" },
    ...(chosenCompany.companyType === "Casa Matriz" ? [
      { id: "sucursales", label: "Sucursales", path: "/Cuenta/Sucursales" }
    ] : [])
  ];

  return (
    <div className="main-container">
      <div className="atendoo-card">
        <div className="profile-header">
          <h6 className="subtitle">Mi Cuenta</h6>
        </div>

        {/* Company Info Section */}
        <div className="company-info-section">
          <div className="company-info">
            <div className="company-avatar">
              <div className="circleAvatar">
                {chosenCompany.companyType === "Sucursal"
                  ? chosenCompany.branchOfficeName.charAt(0).toUpperCase() || "P"
                  : chosenCompany.socialReason.charAt(0).toUpperCase() || "P"}
              </div>
            </div>
            <div className="company-details">
              <h3 className="company-name">
                {chosenCompany.companyType === "Sucursal"
                  ? chosenCompany.branchOfficeName
                  : chosenCompany.socialReason
                }
              </h3>
              <p className="company-type">{chosenCompany.companyType}</p>
            </div>
          </div>
          <div className="company-code">
            <span className="code-label">Código Cliente:</span>
            <span className="code-value">
              {isFranchise
                ? getDisplayClientCode(chosenCompany, true)
                : chosenCompany.managerId}
            </span>
          </div>
        </div>

        {/* Navigation Tabs */}
        <nav className="profile-nav">
          <ul className="nav-tabs">
            {tabs.map((tab) => (
              <li key={tab.id} className="nav-item">
                <Link
                  to={tab.path}
                  className={`nav-link ${currentTab === tab.id ? 'active' : ''}`}
                  onClick={() => setCurrentTab(tab.id)}
                >
                  {tab.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* Content Section */}
        <div className="profile-content">
          {currentTab === "datos" && dataProfiles[chosenCompany.companyType]}
          {currentTab === "contactos" && <Contactos />}
          {chosenCompany.companyType === "Casa Matriz" && currentTab === "sucursales" && <Sucursales />}
        </div>

        <EditCompanyModal
          toggleModal={toggleEditarEmpresa}
          urlTittle={"modalEditarEmpresa"}
        />
      </div>
    </div>
  );
};

const PARTICULAR_PATIENT_PROFILE = () => {
  const reduxStore = useSelector((state: RootState) => state.user);
  const [searchParams] = useSearchParams("");

  const [toggleEditarPaciente, settoggleEditarPaciente] = useState(
    searchParams.get("modalEditarPaciente") === "active"
  );

  useEffect(() => {
    const modalEditarPaciente = searchParams.get("modalEditarPaciente");
    if (modalEditarPaciente === "active") {
      settoggleEditarPaciente(true);
    }
  }, [searchParams]);

  return (
    <div className="main-container">
      <div className="atendoo-card">
        <div className="patient-info-section">
          <div className="patient-header">
            <h6 className="subtitle mb-3">Mi Cuenta</h6>
          </div>

          <div className="patient-info">
            <div className="patient-avatar">
              <div className="circleAvatar">
                {reduxStore?.name?.charAt(0).toUpperCase() || "P"}
              </div>
            </div>
            <div className="patient-details">
              <h3 className="patient-name">{reduxStore?.name}</h3>
              <p className="patient-type">Cliente Particular</p>
            </div>
          </div>

          <div className="patient-notice">
            <div className="notice-content">
              <span className="notice-icon">ⓘ</span>
              <span className="notice-text">
                Si necesita editar sus datos comuníquese con Lavorix
              </span>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="profile-content">
          <DataParticularPatient />
        </div>

        <EditParticularPatientModal
          toggleModal={toggleEditarPaciente}
          urlTittle={"modalEditarPaciente"}
        />
      </div>
    </div>
  );
};

export default PROFILE;